import React from "react";
import CTA from "./CtaSection.js";
import Faq from "./FaqSection.js";
import Team from "./TeamSection.js";
import About from "./AboutSection.js";
import ConsultationServices from "./ConsultationServicesSection.js";
import HireTalentSection from "./HireTalentSection.js";
import Categories from "./CategoriesSection.js";
import Testimonial from "./TestimonialSection.js";
import ScrollToTop from "../../components/Common/ScrollTop/index.js";
import BannerDefault from "../../components/Banner/BannerDefault.js";
import AboutWork from "./AboutWorkSection.js";
import Counter from "./CounterSection.js";
import Service from "./ServiceSection.js";
import ServicesGridSection from "./ServicesGridSection";
import WhyChooseUs from "./WhyChooseUsSection.js";
import KidsInTechSection from "./KidsInTechSection.js";
import DigitalTransformationSection from "./DigitalTransformationSection.js";
import KidsCourses from "./KidsCourseSection.js";
import BrandThree from "../../components/Common/Brand/BrandThree.js";
import NewsEventSection from "./NewsEventSection.js";
import QuoteSection from "./QuoteSection.js";
import AITradingSection from "./AiTradingSection.js";
import UniqueSellingProposition from "./UniqueSellingSection.js";
import ApprochSection from "./ApprochSection.js";

const HomeMain = () => {
  return (
    <React.Fragment>
      <BannerDefault />
      <About />
      <DigitalTransformationSection />
      <Service />
      <Counter />
      <UniqueSellingProposition />
      {/* <AITradingSection /> */}
      {/* <Categories /> */}
      <AboutWork />
      <ConsultationServices />
      {/* <ServicesGridSection /> */}
      <WhyChooseUs />
      <KidsInTechSection />
      <HireTalentSection />
      {/* <KidsCourses /> */}
      <CTA />
      <Faq />
      <ApprochSection />
      <Team />
      <Testimonial />
      <QuoteSection />
      <NewsEventSection />
      <BrandThree />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default HomeMain;
